<!-- ── Mobile layout ── -->
<div *ngIf="isMobile && !isLoading && productId && availableBudgets && availableBudgets.length > 0" class="m-budget-selector">

  <!-- Info row -->
  <div class="m-budget-info">
    <span class="m-budget-info-label">Total Cost</span>
    <span class="m-budget-info-value">
      <ng-container *ngIf="totalCost !== null; else mbLoadingCost">{{ totalCost | currency:'ZAR' }}</ng-container>
      <ng-template #mbLoadingCost><span class="text-muted">Loading…</span></ng-template>
    </span>
  </div>

  <!-- Assignments -->
  <form [formGroup]="form">
    <div formArrayName="assignments">
      <div *ngFor="let assignment of assignments.controls; let i = index" [formGroupName]="i" class="m-budget-row">
        <app-single-select-dropdown
          [options]="budgetOptions"
          [selectedValue]="assignment.get('budgetID')?.value != null ? assignment.get('budgetID')?.value.toString() : null"
          placeholder="Select budget"
          (selectedValueChange)="onMobileBudgetChange(i, $event)">
        </app-single-select-dropdown>
        <div class="m-budget-amount-row">
          <span class="m-budget-currency">ZAR</span>
          <input type="number" class="form-control m-budget-amount-input"
                 formControlName="amount"
                 min="0.01" step="0.01" placeholder="0.00"
                 (input)="onAmountChange()"
                 (blur)="formatAmount($event, i)">
          <button type="button" class="m-budget-remove-btn"
                  (click)="removeAssignment(i)"
                  [disabled]="assignments.length <= 1">
            <i class="bi bi-trash"></i>
          </button>
        </div>
        <div class="m-budget-validation" *ngIf="hasUserInteracted && (assignment.get('budgetID')?.invalid || !assignment.get('budgetID')?.value)">
          Please select a budget
        </div>
      </div>
    </div>
  </form>

  <!-- Add button -->
  <button type="button" class="m-budget-add-btn" (click)="addAssignment()" [disabled]="!productId || availableBudgets.length === 0">
    <i class="bi bi-plus"></i> Add Budget
  </button>

  <!-- Progress -->
  <div class="m-budget-progress-wrap" *ngIf="totalCost && totalCost > 0 && hasUserInteracted">
    <div class="m-budget-progress-labels">
      <span>Assigned: ZAR {{ totalAssigned | number:'1.2-2' }}</span>
      <span>Remaining: ZAR {{ remainingAmount | number:'1.2-2' }}</span>
    </div>
    <div class="progress" style="height: 8px;">
      <div class="progress-bar"
           role="progressbar"
           [ngClass]="{ 'bg-success': totalAssigned === totalCost, 'bg-warning': totalAssigned < totalCost, 'bg-danger': totalAssigned > totalCost }"
           [style.width.%]="progressPercentage > 100 ? 100 : progressPercentage">
      </div>
    </div>
    <small class="text-muted">{{ progressPercentage | number:'1.0-0' }}% of total cost assigned</small>
  </div>

  <!-- Validation alerts -->
  <div class="m-budget-alert m-budget-alert--danger" *ngIf="hasUserInteracted && totalAssigned > (totalCost || 0)">
    <i class="bi bi-x-circle me-1"></i>{{ validation.message }}
  </div>
  <div class="m-budget-alert m-budget-alert--success" *ngIf="hasUserInteracted && totalAssigned > 0 && totalAssigned === (totalCost || 0)">
    <i class="bi bi-check-circle me-1"></i>{{ validation.message }}
  </div>
</div>

<!-- Loading / empty states for mobile -->
<div *ngIf="isMobile && isLoading" class="text-center py-3">
  <div class="spinner-border text-primary" role="status"><span class="visually-hidden">Loading…</span></div>
</div>
<div *ngIf="isMobile && !isLoading && productId && (!availableBudgets || availableBudgets.length === 0)" class="m-budget-alert m-budget-alert--warn">
  <i class="bi bi-exclamation-triangle me-1"></i>No budgets available.
</div>

<!-- ── Desktop layout ── -->
<div class="budget-selector" *ngIf="!isMobile">
  <!-- Alert Display -->
  <!-- <div class="mb-3" *ngIf="showAlert">
    <div class="alert"
         [ngClass]="alertType === 'success' ? 'alert-success' : 'alert-danger'"
         role="alert">
      <h5 class="alert-heading">{{alertTitle}}</h5>
      <p class="mb-0" style="white-space: pre-line;">{{alertMessage}}</p>
      <button type="button" class="btn-close" (click)="onAlertClosed()" aria-label="Close"></button>
    </div>
  </div> -->

  <!-- Loading State -->
  <div *ngIf="isLoading" class="text-center py-3">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <p class="mt-2 mb-0">Loading product cost information...</p>
  </div>

  <!-- Error State -->
  <div *ngIf="error && !isLoading" class="alert alert-danger">
    <i class="bi bi-exclamation-triangle me-2"></i>
    {{ error }}
  </div>

  <!-- No Product Selected -->
  <div *ngIf="!productId && !isLoading" class="text-center py-4">
    <div class="alert alert-info mb-0">
      <div class="d-flex align-items-center">
        <i class="bi bi-info-circle me-2 fs-4"></i>
        <div>
          <h5 class="mb-1">No Product Selected</h5>
          <p class="mb-0">Please select a product above to allocate budgets</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Main Content -->
  <div *ngIf="!isLoading && productId">
    <!-- No Budgets Available -->
    <div *ngIf="!availableBudgets || availableBudgets.length === 0" class="alert alert-warning">
      <i class="bi bi-exclamation-triangle me-2"></i>
      No budgets available. Please create budgets first.

    </div>

    <div *ngIf="productId && availableBudgets && availableBudgets.length > 0">
    <!-- Product Info -->
    <div *ngIf="productName" class="form-section category-section mb-4">
      <div class="card-header bg-light">
        <h6 class="mb-0">Budget Allocation</h6>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <p class="mb-1"><strong>Product:</strong> {{ productName }}</p>
          </div>
          <div class="col-md-6 text-md-end">
            <p class="mb-1"><strong>Total Cost:</strong>
              <span *ngIf="totalCost !== null; else loadingCost">
                {{ totalCost | currency:'ZAR' }}
              </span>
              <ng-template #loadingCost>
                <span class="text-muted">Loading...</span>
              </ng-template>
            </p>
            <p class="mb-1"><strong>Total Assigned:</strong> {{ totalAssigned | currency:'ZAR' }}</p>
            <p class="mb-1" [class.text-danger]="remainingAmount < 0" [class.text-success]="remainingAmount >= 0">
              <strong>Remaining:</strong>
              <span *ngIf="totalCost !== null">
                {{ remainingAmount | currency:'ZAR' }}
              </span>
              <span *ngIf="totalCost === null" class="text-muted">-</span>
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Budget Assignments -->
    <div class="form-section item-section mb-4 p-3">
      <div *ngIf="!isLoading">
        <div class="d-flex justify-content-between align-items-center mb-3">

          <button type="button" class="btn btn-sm btn-teal-gradient"
                  (click)="addAssignment()"
                  [disabled]="!productId || availableBudgets.length === 0">
            <i class="bi bi-plus"></i> Add Budget
          </button>

          <button *ngIf="availableBudgets.length < 1" type="button"
                  class="btn btn-sm btn-teal-gradient"
                  (click)="navigateToCosting($event)">
            <i class="bi bi-plus"></i> Create New Budget
          </button>
        </div>

          <div class="alert alert-danger" *ngIf="totalAssigned > (totalCost || 0)">
            <i class="bi bi-x-circle me-2"></i>
            {{ validation.message }}
          </div>

          <div class="alert alert-success" *ngIf="totalAssigned > 0 && totalAssigned === (totalCost || 0)">
            <i class="bi bi-check-circle me-2"></i>
            {{ validation.message }}
          </div>
        </div>


        <!-- Budget Assignment Form -->
        <form [formGroup]="form">
          <div formArrayName="assignments">
            <div *ngFor="let assignment of assignments.controls; let i = index" [formGroupName]="i" >
              <div class="row g-3 align-items-end">
                <div class="col-sm-5">
                  <label [for]="'budget-' + i" class="form-label mb-1">Budget</label>
                  <select
                    [id]="'budget-' + i"
                    class="form-select"
                    formControlName="budgetID"
                    (change)="onBudgetChange($event, i)">
                    <option [ngValue]="null" disabled>Select a budget</option>
                    <option *ngFor="let budget of availableBudgets; let idx = index" [value]="budget.budgetID">
                      {{ budget.budgetName }} ({{ getBudgetPeriodLabel(budget) }})
                    </option>
                  </select>
                  <div class="invalid-feedback d-block" *ngIf="hasUserInteracted && (assignment.get('budgetID')?.invalid || !assignment.get('budgetID')?.value)">
                    Please select a budget
                  </div>
                </div>

                <div class="col-sm-5">
                  <label [for]="'amount-' + i" class="form-label mb-1">Amount (ZAR)</label>
                  <div class="input-group">
                    <span class="input-group-text">ZAR</span>
                    <input
                      type="number"
                      [id]="'amount-' + i"
                      class="form-control"
                      formControlName="amount"
                      min="0.01"
                      step="0.01"
                      placeholder="0.00"
                      (input)="onAmountChange()"
                      (blur)="formatAmount($event, i)">
                  </div>
                  <div class="invalid-feedback d-block" *ngIf="assignment.get('amount')?.invalid && assignment.get('amount')?.touched">
                    Please enter a valid amount
                  </div>
                </div>

                <div class="col-sm-2 d-flex align-items-center justify-content-center">
                  <button type="button" class="btn btn-outline-danger" (click)="removeAssignment(i)" [disabled]="assignments.length <= 1">
                    <i class="bi bi-trash"></i>
                  </button>
                </div>
              </div>

            </div>
          </div>

          <div class="d-flex justify-content-between align-items-center mt-3">


            <div class="text-end">
              <div class="mb-2" *ngIf="totalCost">
                <strong>Total Cost:</strong> ZAR {{ totalCost | number:'1.2-2' }}
              </div>
              <!-- <div class="d-flex gap-2">
                <button type="button" class="btn btn-outline-secondary" (click)="clearAssignments()" [disabled]="assignments.length === 0">
                  Clear All
                </button>
                <button type="button" class="btn btn-primary" [disabled]="!isValid || !hasUserInteracted" (click)="onSaveAssignments()">
                  Save Assignments
                </button>
              </div> -->
            </div>
          </div>
        </form>

        <!-- Progress Bar -->
        <div class="mb-3" *ngIf="totalCost && totalCost > 0 && hasUserInteracted">
          <div class="d-flex justify-content-between mb-1">
            <span>Assigned: ZAR {{ totalAssigned | number:'1.2-2' }}</span>
            <span>Remaining: ZAR {{ remainingAmount | number:'1.2-2' }}</span>
          </div>
          <div class="progress" style="height: 10px;">
            <div class="progress-bar"
                 role="progressbar"
                 [ngClass]="{
                   'bg-success': totalAssigned === totalCost,
                   'bg-warning': totalAssigned < totalCost,
                   'bg-danger': totalAssigned > totalCost
                 }"
                 [style.width.%]="progressPercentage > 100 ? 100 : progressPercentage"
                 [attr.aria-valuenow]="progressPercentage"
                 aria-valuemin="0"
                 aria-valuemax="100">
            </div>
          </div>
          <small class="text-muted">
            {{ progressPercentage | number:'1.0-0' }}% of total cost assigned
          </small>
        </div>
      </div>
    </div>

    <!-- Budget Creation Prompt -->
    <div *ngIf="!isLoading && availableBudgets.length === 0" class="mt-3">

        <button *ngIf="availableBudgets.length < 1" type="button"
        class="btn btn-sm btn-teal-gradient"
        (click)="navigateToCosting($event)">
  <i class="bi bi-plus"></i> Create New Budget
</button>

  </div>
</div>
<!-- /desktop layout -->
